export default __webpack_public_path__ + "static/media/midle-right-ellipse.63a63e86.svg";